import {InjectionToken} from '@angular/core';
import {Environment} from './runtime-environments/environment.interface';

export const APP_META_TAG_ENV_PROFILE: InjectionToken<string> = new InjectionToken<string>('APP_META_TAG_ENV_PROFILE');
export const APP_ENV: InjectionToken<Environment> = new InjectionToken<Environment>('APP_ENV');
